import { useEffect, useState } from "react";
import { ExternalLink } from "lucide-react";
import { api } from "@/lib/api";
import { SectionHeading } from "./SectionHeading";
import { useText } from "@/lib/useText";

export function CommunitySection({ community, links, discord }) {
  const [widget, setWidget] = useState(null);
  const t = useText();

  useEffect(() => {
    let alive = true;
    const load = () => api.get("/discord/widget").then(({ data }) => alive && setWidget(data)).catch(() => alive && setWidget({ available: false }));
    load();
    const t = setInterval(load, 60000);
    return () => { alive = false; clearInterval(t); };
  }, []);

  return (
    <section data-reveal className="border-t border-eden-border py-20 sm:py-28" aria-labelledby="comunidade-title" data-testid="community-section">
      <div className="container-eden grid gap-12 lg:grid-cols-12 lg:gap-16">
        <div className="lg:col-span-6">
          <SectionHeading id="comunidade-title" eyebrow={community.eyebrow} title={community.title} text={community.text} />
          <dl className="mt-10 grid grid-cols-2 gap-px overflow-hidden rounded-md border border-eden-border bg-eden-border sm:max-w-md">
            <div className="bg-eden-surface p-5">
              <dt className="font-mono text-[11px] uppercase tracking-widest text-eden-muted">{t("community_state")}</dt>
              <dd className="mt-2 flex items-center gap-2 font-display text-lg font-semibold text-eden-text" data-testid="discord-status">
                <span className={`h-2 w-2 rounded-full ${widget?.available ? "bg-emerald-500" : "bg-eden-muted"}`} aria-hidden="true" />
                {widget === null ? t("status_checking") : widget.available ? t("community_active") : t("community_unavailable")}
              </dd>
            </div>
            <div className="bg-eden-surface p-5">
              <dt className="font-mono text-[11px] uppercase tracking-widest text-eden-muted">{t("community_online")}</dt>
              <dd className="mt-2 font-display text-lg font-semibold tabular-nums text-eden-text" data-testid="discord-online-count">
                {widget?.presence_count != null ? widget.presence_count : "0"}
              </dd>
            </div>
          </dl>
          <a href={links.discord_invite} target="_blank" rel="noopener noreferrer" className="btn-primary mt-10" data-testid="discord-join-button">
            {community.button_label} <ExternalLink size={16} aria-hidden="true" />
          </a>
        </div>
        <div className="lg:col-span-6">
          <div className="card-eden overflow-hidden">
            <iframe
              title="Widget oficial do Discord EDEN RP"
              src={`https://discord.com/widget?id=${discord.guild_id}&theme=dark`}
              width="100%"
              height="420"
              sandbox="allow-popups allow-popups-to-escape-sandbox allow-same-origin allow-scripts"
              loading="lazy"
              className="block w-full"
              data-testid="discord-widget-iframe"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
